import { Box, Button, Dialog, IconButton } from "@mui/material";
import Switch from "@mui/material/Switch";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { replacementScheduleColumnData } from "../../common/constants/gridRowColumn";
import {
  useCompany,
  useDealer,
  useFleetList,
  useMovableColumn,
  useNewVehicle,
  usePagination,
  useReplacement,
  useSortableColumn,
  useUser,
} from "../../common/hooks";
import { layoutStyle } from "../layout-ui/style";
import { TruckLoader } from "./truckLoader";
import { useDebounce } from "../../components/useDebounce";
import {
  actionColumnFunction,
  checkFieldColumn,
  checkbox,
  getDefaultColDef,
} from "../../common/constants/commonFunction";
import { getCompanyId } from "../../common/constants/commonFunction";
import { ReplacementHeaderButton } from "../../components/ReplacementHeaderButton";
import { TAB_CONTENT, TAB_VALUE } from "../../common/constants/popupMessage";
import {
  ReplacementYearToggle,
  YearConstant,
  yearCountValue,
} from "../../common/constants/replacementSchedule";
import { localStorageItemNames } from "../../common/constants";
import { PageNameConstant } from "../../common/constants/PageNameConstant";
import { Edit } from "@mui/icons-material";
import { onSortChanged } from "../../common/utils/sortingColumn";
import {
  getCurrencyReplacementValue,
  getCurrencyValue,
} from "../../common/services/number-service";
import { showErrorToast, showToast } from "../../components/Toast";

export const ReplacementSchedule = () => {
  const classes = layoutStyle();
  const [columnFinal, setColumnFinal] = useState([]);
  const [rowDataFinal, setRowDataFinal] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const {
    selectedNav,
    setSelectedNav,
    columnChange,
    setColumnChange,
    setSidebarColumnPopup,
  } = useUser();
  const navigation = useNavigate();
  const {
    getReplacementListApi,
    replacementList,
    editReplacementListApi,
    setEditData,
    loading,
    editData,
    setReplacementList,
  } = useReplacement();
  const {
    manualCalculationApi,
    setNewFleetNo,
    multipleManualCalculationApi,
    updateManualCalculationsFleetYearApi,
    resetReplacementScheduleApi,
  } = useDealer();
  const { companyNameHeader, dealerNameHeader } = useCompany();
  const userType = localStorage.getItem("type");
  const defaultColDef = useMemo(() => getDefaultColDef(), []);

  const [anchorElSearch, setAnchorElSearch] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [averageMileage, setAverageMileage] = useState(0);
  const [checkedValue, setCheckedValue] = useState({
    year1: false,
    year2: false,
    year3: false,
    year4: false,
    year5: false,
  });
  const { getFleetListApi, fleetList } = useFleetList();
  const { setToastClose, setNewVehicle } = useNewVehicle();
  const [countYear, setCountYear] = useState({
    year1: 0,
    year2: 0,
    year3: 0,
    year4: 0,
    year5: 0,
  });
  const gridRef = useRef(null);
  const [movableColumnData, setMovableColumnData] = useState([]);
  const {
    movableColumn,
    getMovableColumnApi,
    createMovableColumn,
    updateViewMovableColumn,
    sortedColumn,
    setSortedColumn,
  } = useMovableColumn();

  const {
    getSortableColumnApi,
    sortableColumnData,
    createSortableColumn,
    updateViewSortableColumn,
  } = useSortableColumn();

  const {
    pagination,
    setPagination,
    setFleetPagination,
    setMaintainancePagination,
    setFuelPagination,
    setFundingPagination,
  } = usePagination();
  const [openResetDialog, setOpenResetDialog] = useState(false);
  const onSearch = (e) => {
    debouncedSearch(e?.target?.value);
    handleClickSearch(e);
  };
  const handleClickSearch = (event) => {
    setAnchorElSearch(event.currentTarget);
  };

  const onSearchFunc = (e) => {
    setSearchValue(e[0]);
  };
  const searchData = replacementList?.filter((replacement) =>
    replacement?.fleetNo?.toLowerCase().includes(searchValue?.toLowerCase())
  );
  const debouncedSearch = useDebounce(onSearchFunc, 500);

  useEffect(() => {
    if (searchValue) {
      setRowDataFinal([...searchData]);
    } else if (replacementList?.length > 0) {
      setRowDataFinal([...replacementList]);
    } else {
      setRowDataFinal([]);
    }
  }, [searchValue, replacementList]);

  const handleEditButton = (params) => {
    const itemId = params.id;
    const fleetNo = params.fleetNo;
    setEditData(params);
    sessionStorage.removeItem("initialReplacementSchedule");
    navigation("/new-fleetlist", {
      state: {
        tabValue: TAB_VALUE.REPLACEMENT_SCHEDULE,
        selectedContent: TAB_CONTENT.REPLACEMENT_SCHEDULE,
        data: params,
        selectedRows: selectedRows?.length > 0 ? selectedRows : [params],
        id: itemId,
        fleetNo: fleetNo,
      },
    });
  };

  const onCellClicked = (event) => {
    if (
      event?.colDef?.field !== "year1" &&
      event?.colDef?.field !== "year2" &&
      event?.colDef?.field !== "year3" &&
      event?.colDef?.field !== "year4" &&
      event?.colDef?.field !== "year5"
    ) {
      let checkField = checkFieldColumn(event);
      if (checkField) {
        handleEditButton(event?.data);
      }
    }
  };

  useEffect(() => {
    getSortableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      },
    });
    getMovableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.replacementSchedule,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      },
    });
    setEditData(null);
    getFleetListApi({
      companyId: getCompanyId(userType, companyNameHeader),
      dealerId: dealerNameHeader?.id,
    });
    setNewFleetNo(null);
    setToastClose(false);
    setNewVehicle([]);
    setSidebarColumnPopup("");
    setFleetPagination(0);
    setMaintainancePagination(0);
    setFuelPagination(0);
    setFundingPagination(0);
  }, []);

  useEffect(() => {
    setColumnChange(false);
    getSortableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      },
    });
    getMovableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.replacementSchedule,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      },
    });
    if (companyNameHeader) {
      sessionStorage.removeItem("initialReplacementSchedule");
      setReplacementList([]);
      const companyId = getCompanyId(userType, companyNameHeader);
      getReplacementListApi({
        companyId: companyId,
        dealerId: dealerNameHeader?.id,
      });
    } else {
      setRowDataFinal([]);
      setReplacementList([]);
    }
  }, [companyNameHeader, dealerNameHeader]);

  useEffect(() => {
    if (sortableColumnData?.length > 0) {
      let sortingColumnData = sortableColumnData[0]?.fleetDetails;
      let sortingValue = JSON.parse(sortingColumnData);
      setSortedColumn([...sortingValue]);
    }
  }, [sortableColumnData]);
  useEffect(() => {
    if (sortedColumn?.length > 0 && replacementList?.length > 0) {
      const dataFinal = [];

      // Step 1: Add matching fleet numbers in the correct sequence
      sortedColumn.forEach((fleetNo) => {
        const match = replacementList.find((item) => item.fleetNo === fleetNo);
        if (match) dataFinal.push(match);
      });

      // Step 2: Append remaining fleet numbers (not in sortedColumn)
      const remainingData = replacementList.filter(
        (item) => !sortedColumn.includes(item.fleetNo)
      );

      dataFinal.push(...remainingData);
      setRowDataFinal([...dataFinal]);
    } else if (replacementList?.length > 0) {
      setRowDataFinal([...replacementList]);
    } else {
      setRowDataFinal([]);
    }
  }, [replacementList, sortedColumn]);

  useEffect(() => {
    if (movableColumnData?.length > 0) {
      setColumnFinal([...movableColumnData]);
    }
    //   if (replacementScheduleColumnData) {
    //     const actionColumn = actionColumnFunction({
    //       selectedRows: selectedRows,
    //       handleEditButton: handleEditButton,
    //       deleteButton: false,
    //     });
    //     replacementScheduleColumnData?.map((items) => {
    //       if (
    //         items.field == YearConstant.year1 ||
    //         items.field == YearConstant.year2 ||
    //         items.field == YearConstant.year3 ||
    //         items.field == YearConstant.year4 ||
    //         items.field == YearConstant.year5
    //       ) {
    //         items["cellRenderer"] = (params) => (
    //           <Switch
    //             onChange={(params1) => handleSwitchButton(params, items, params1)}
    //             defaultChecked={params.value}
    //             size="small"
    //           />
    //         );
    //       }
    //     });
    //     setColumnFinal([
    //       checkbox,
    //       ...replacementScheduleColumnData,
    //       actionColumn,
    //     ]);
    //   }
  }, [movableColumnData]);

  const handleSwitchButton = async (event, values, params1) => {
    setPagination(event?.api?.paginationGetCurrentPage());
    if (selectedRows.length == 0) {
      const fleet = fleetList?.filter(
        (fleet) => fleet?.fleetId === event?.data?.fleetId
      );
      let fleetNo;
      if (fleet?.length > 0) {
        fleetNo = fleet[0];
      }
      let year = ReplacementYearToggle(values?.field, params1, event);
      let editPayload = {
        ...year,
        fleetNo: event?.data?.fleetNo,
        companyId: event?.data?.companyId,
        id: event?.data?.replacementId,
        dealerId: event?.data?.dealerId,
      };

      let manualCalculation = {
        year: event?.data?.year,
        totalMiles: event?.data?.totalMiles,
        make: event?.data?.make,
        model: event?.data?.model,
        vin: event?.data?.vin,
        stateCode: event?.data?.stateCode,
        dealer: event?.data?.dealerName,
        company: event?.data?.companyName,
        typeId: event?.data?.typeId,
        fleetNo: event?.data?.fleetNo,
        cyclingFuelEco: 0,
        replacementSchedule: {
          id: event?.data?.replacementId,
          deleted: false,
          fleetNo: event?.data?.fleetNo,
          ...year,
        },
        mpg: event?.data?.mpg,
        stateName: event?.data?.state,
      };
      setCheckedValue({
        ...checkedValue,
        [values.field]: params1.target.checked,
      });
      await editReplacementListApi(editPayload);
      await manualCalculationApi(manualCalculation);
    }
    else {
      const isRowSelected = selectedRows?.some(
        (item) => item?.fleetNo === event?.data?.fleetNo
      );

      if (isRowSelected && selectedRows?.length > 1) {
        let multiEditPayload = {
          fleetNo: selectedRows.map((row) => row.fleetNo),
          [values?.field]: params1.target.checked,
        };
        await updateManualCalculationsFleetYearApi(multiEditPayload);
        const companyId = getCompanyId(userType, companyNameHeader);
        setTimeout(async () => {
          setSelectedRows([]);
          await getReplacementListApi({
            companyId: companyId,
            dealerId: dealerNameHeader?.id,
          });
          showToast("Fleets updated successfully!");
        }, 1000);
      } else {
        let year = ReplacementYearToggle(values?.field, params1, event);
        let multiEditPayload = {
          fleetNo: [event?.data?.fleetNo],
          ...year,
        };
        await updateManualCalculationsFleetYearApi(multiEditPayload);
        setSelectedRows([]);
        const companyId = getCompanyId(userType, companyNameHeader);

        await getReplacementListApi({
          companyId: companyId,
          dealerId: dealerNameHeader?.id,
        });
        showToast("Fleets updated successfully!");
      }
    }
  };
  useEffect(() => {
    if (replacementList?.length > 0) {
      const totalAnnualMileage = replacementList?.reduce((sum, item) => {
        return sum + (item?.annualMileage || 0);
      }, 0);
      if (totalAnnualMileage > 0) {
        const averageMileage = (
          totalAnnualMileage / replacementList?.length
        )?.toFixed(2);
        setAverageMileage(averageMileage);
      }
      const { year1, year2, year3, year4, year5 } =
        yearCountValue(replacementList);
      setCountYear({
        year1: year1,
        year2: year2,
        year3: year3,
        year4: year4,
        year5: year5,
      });
      // handleUpdateCalculation();
    }
  }, [replacementList]);


  const handleConfirmReset = async () => {
    const companyId = getCompanyId(userType, companyNameHeader);
    const response = await resetReplacementScheduleApi({
      companyId: Number(companyId),
      dealerId: Number(dealerNameHeader?.id),
    });
    if (response?.succeeded) {
      showToast("Schedule reset successfully!");
      setOpenResetDialog(false);
      getReplacementListApi({
        companyId: companyId,
        dealerId: dealerNameHeader?.id,
      });
    } else {
      showToast("Failed to reset schedule.");
    }
  };
  const handleUpdateCalculation = async (event) => {
    const data = [];
    replacementList?.map((items) => {
      let payload = {
        companyId: companyNameHeader?.id,
        dealerId: dealerNameHeader?.id,
        company: items.companyName,
        dealer: items.dealerName,
        vin: items.vin,
        stateCode: items.stateCode,
        stateName: items.state,
        make: items.make,
        model: items.model,
        fuelId: items.fuelId,
        typeId: items.typeId,
        fleetNo: items.fleetNo,
        mpg: Number(items.mpg),
        year: items.year,
        cyclingFuelEco: items.cyclingFuelEco,
        totalMiles: items.totalMiles,
        replacementSchedule: {
          fleetNo: items.fleetNo,
          id: items.replacementId,
          year1: items.year1,
          year2: items.year2,
          year3: items.year3,
          year4: items.year4,
          year5: items.year5,
        },
      };
      data.push(payload);
    });
    await multipleManualCalculationApi(data);
  };
  const handleRowSelection = (event) => {
    setSelectedRows(event.api.getSelectedNodes().map((node) => node.data));
  };
  useEffect(() => {
    if (rowDataFinal?.length > 0 && editData == null) {
      if (replacementList?.length > 0) {
        // handleUpdateCalculation();
      }
    }
  }, [replacementList]);

  useEffect(() => {
    const paginationPanel = document.querySelector(".ag-paging-panel");
    if (paginationPanel) {
      let totalSavingsDiv = document.querySelector(".custom-total-savings");
      if (!totalSavingsDiv) {
        totalSavingsDiv = document.createElement("div");
        totalSavingsDiv.className = `${classes.analysisTotalSavingButton} custom-total-savings`;
        paginationPanel.appendChild(totalSavingsDiv);
      }
      totalSavingsDiv.innerHTML = `<div class="${classes.totalAnnualMileageText
        }">Average Annual Mileage: ${getCurrencyReplacementValue(
          averageMileage
        )}</div>`;
    }
  }, [averageMileage]);

  useEffect(() => {
    if (sortableColumnData?.length > 0 && movableColumn?.length > 0) {
      let dataMovable = movableColumn[0];
      let columnParse = JSON.parse(dataMovable?.columnName);
      if (sortableColumnData?.length > 0) {
        columnParse?.map((item) => {
          if (
            item.field === sortableColumnData[0].sortedColumn &&
            sortableColumnData[0].pageName ===
            PageNameConstant.replacementSchedule
          ) {
            item["sort"] = sortableColumnData[0].direction;
          } else {
            item["sort"] = null;
          }
        });
      }
      columnParse?.map((items) => {
        if (
          items.field == YearConstant.year1 ||
          items.field == YearConstant.year2 ||
          items.field == YearConstant.year3 ||
          items.field == YearConstant.year4 ||
          items.field == YearConstant.year5
        ) {
          items["cellRenderer"] = (params) => (
            <Switch
              onChange={(params1) => handleSwitchButton(params, items, params1)}
              defaultChecked={params.value}
              size="small"
            />
          );
        }
        if (items.field == "action") {
          items["cellRenderer"] = (params) => (
            <>
              <IconButton
                style={{
                  color: selectedRows?.includes(params?.id) ? "white" : "black",
                }}
                onClick={() => handleEditButton(params.data)}
              >
                <Edit />
              </IconButton>
            </>
          );
        }
      });
      setMovableColumnData(columnParse);
    } else if (movableColumn?.length > 0) {
      let dataMovable = movableColumn[0];
      let columnParse = JSON.parse(dataMovable?.columnName);
      columnParse?.map((items) => {
        if (
          items.field == YearConstant.year1 ||
          items.field == YearConstant.year2 ||
          items.field == YearConstant.year3 ||
          items.field == YearConstant.year4 ||
          items.field == YearConstant.year5
        ) {
          items["cellRenderer"] = (params) => (
            <Switch
              onChange={(params1) => handleSwitchButton(params, items, params1)}
              defaultChecked={params.value}
              size="small"
            />
          );
        }
        if (items.field == "action") {
          items["cellRenderer"] = (params) => (
            <>
              <IconButton
                style={{
                  color: selectedRows?.includes(params?.id) ? "white" : "black",
                }}
                onClick={() => handleEditButton(params.data)}
              >
                <Edit />
              </IconButton>
            </>
          );
        }
      });
      setMovableColumnData(columnParse);
    } else {
      const actionColumn = actionColumnFunction({
        selectedRows: selectedRows,
        handleEditButton: handleEditButton,
        deleteButton: false,
      });
      replacementScheduleColumnData?.map((items) => {
        if (
          items.field == YearConstant.year1 ||
          items.field == YearConstant.year2 ||
          items.field == YearConstant.year3 ||
          items.field == YearConstant.year4 ||
          items.field == YearConstant.year5
        ) {
          items["cellRenderer"] = (params) => (
            <Switch
              onChange={(params1) => handleSwitchButton(params, items, params1)}
              defaultChecked={params.value}
              size="small"
            />
          );
        }
      });
      setMovableColumnData([
        checkbox,
        ...replacementScheduleColumnData,
        actionColumn,
      ]);
    }
  }, [replacementScheduleColumnData, movableColumn, selectedRows]);
  const handleColumnChange = (event) => {
    if (event?.column) {
      const cols = gridRef.current?.api?.getAllGridColumns();
      const colNamesIndex = cols?.map((items, index) => items?.colDef);
      setMovableColumnData(colNamesIndex);
      setColumnChange(true);
    }
  };
  const isFirstRender = useRef(true);
  const onResetReplacement = async () => {
    setOpenResetDialog(true);
  };
  useEffect(() => {
    if (pagination && gridRef?.current?.api) {
      gridRef?.current?.api?.paginationGoToPage(pagination);
    }
  }, [pagination, rowDataFinal]);

  return (
    <Box className={classes.mainContent}>
      <Box className={classes.gridContantFleetList}>
        <ReplacementHeaderButton
          onSearch={onSearch}
          setSelectedNav={setSelectedNav}
          countYear={countYear}
          columnChange={columnChange}
          movableColumnData={movableColumnData}
          setMovableColumnData={setMovableColumnData}
          movableColumn={movableColumn}
          updateViewMovableColumn={updateViewMovableColumn}
          createMovableColumn={createMovableColumn}
          setColumnChange={setColumnChange}
          gridRef={gridRef}
          columnFinal={columnFinal}
          sortedColumn={sortedColumn}
          sortableColumnData={sortableColumnData}
          setColumnFinal={setColumnFinal}
          createSortableColumn={createSortableColumn}
          updateViewSortableColumn={updateViewSortableColumn}
          pageName={PageNameConstant.replacementSchedule}
          isFirstRender={isFirstRender}
          setSortedColumn={setSortedColumn}
          onResetReplacement={onResetReplacement}
        />
        {loading ? (
          <TruckLoader />
        ) : (
          <AgGridReact
            ref={gridRef}
            className="ag-theme-quartz"
            onRowSelectionModelChange={(ids) => {
              const selectedIDs = new Set(ids);
              const selectedRows = rowDataFinal.filter((row) =>
                selectedIDs.has(row.id)
              );
              setSelectedRows(selectedRows);
            }}
            onColumnMoved={handleColumnChange}
            rowSelection="multiple"
            suppressRowClickSelection
            pagination={true}
            paginationPageSize={100}
            rowData={rowDataFinal}
            defaultColDef={defaultColDef}
            checkboxSelection
            columnDefs={columnFinal}
            onCellClicked={onCellClicked}
            onSelectionChanged={handleRowSelection}
          />
        )}
      </Box>
      <Dialog
        open={openResetDialog}
        onClose={() => setOpenResetDialog(false)}
        PaperProps={{
          style: {
            borderRadius: "16px",
            padding: "10px",
            background: "linear-gradient(145deg, #ffffff, #f0f0f0)",
            boxShadow: "20px 20px 60px #d9d9d9, -20px -20px 60px #ffffff",
          },
        }}
      >
        <Box sx={{ p: 2, textAlign: "center" }}>
          <h2 style={{ color: "#333", marginBottom: "16px" }}>Reset Schedule?</h2>
          <p style={{ color: "#666", marginBottom: "24px" }}>
            Are you sure you want to restore the initial schedule state? This
            will undo all your current changes.
          </p>
          <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
            <Button
              variant="outlined"
              onClick={() => setOpenResetDialog(false)}
              sx={{
                borderRadius: "8px",
                textTransform: "none",
                px: 4,
                borderColor: "#ccc",
                color: "#666",
                "&:hover": { borderColor: "#999", backgroundColor: "#f5f5f5" },
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleConfirmReset}
              sx={{
                borderRadius: "8px",
                textTransform: "none",
                px: 4,
                backgroundColor: "#2e7d32",
                "&:hover": { backgroundColor: "#1b5e20" },
              }}
            >
              Confirm
            </Button>
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
};
